import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AchievementDefinitionDto } from "../../../models/achievement/dto/achievement.dto";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_ACHIEVEMENTS_QUERY_KEY } from "./useListAchievements";

export const useToggleAchievement = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (achievementId: string) => {
            if (!selectedOrganization?.id) throw new Error('No organization selected');
            return client.fetchApi<AchievementDefinitionDto, {}>({
                endpoint: `achievements/admin/${selectedOrganization.id}/${achievementId}/toggle`,
                method: 'PATCH',
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_ACHIEVEMENTS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
